import { TestIdDomain } from 'constants/testIds';

export const PresenceAvatarGroupTestIds = {
  SURPLUS: `${TestIdDomain.PRESENCE}.surplus`,
};
